import AccountPage from '@/components/libs/omneo/components/AccountProfileLayout'
import { NavigationProfileIcon } from '@/components/libs/omneo/components/NavigationProfileIcon'
import register from 'preact-custom-element'
register(AccountPage, 'x-account')
register(NavigationProfileIcon, 'x-navigation-profile-icon')
